export default {
  help: {
    fullAccess: '{"type": "help"}',
    readAccess: '{"type": "session"}',
  },

  incomeDocument: {
    uploadAccess: function (userId) {
      return '{"type": "income-document", "id": "' + userId + '"}';
    },
    fullAccess: function (userId) {
      return '{"type": "income-document", "id": "' + userId + '"}';
    },
    readAccess: function (userId) {
      return '{"type": "income-document", "id": "' + userId + '"}';
    },
  },

  school: {
    uploadAccess: function (userId) {
      return '{"type": "school-uploader", "id": "' + userId + '"}';
    },
    fullAccess: function (schoolId) {
      return '{"type": "school-admin", "id": "' + schoolId + '"}';
    },
    readAccess: function (schoolId) {
      return '{"type": "school", "id": "' + schoolId + '"}';
    },
  },

  assignment: {
    uploadAccess: function (userId) {
      return '{"type": "assignment-uploader", "id": "' + userId + '"}';
    },
    fullAccess: function (assignmentId) {
      return '{"type": "assignment-admin", "id": "' + assignmentId + '"}';
    },
    readAccess: function (assignmentId) {
      return '{"type": "assignment", "id": "' + assignmentId + '"}';
    },
  },

  planning: {
    uploadAccess: function (userId) {
      return '{"type": "planning-uploader", "id": "' + userId + '"}';
    },
    fullAccess: function (planningId) {
      return '{"type": "planning-admin", "id": "' + planningId + '"}';
    },
    readAccess: function (planningId) {
      return '{"type": "planning", "id": "' + planningId + '"}';
    },
  },

  conversation: {
    uploadAccess: function (userId) {
      return '{"type": "conversation-uploader", "id": "' + userId + '"}';
    },
    fullAccess: function (conversationId, userId) {
      return (
        '{"type": "conversation-admin", "id": "' +
        conversationId +
        '", "userId": "' +
        userId +
        '"}'
      );
    },
    readAccess: function (conversationId, userId) {
      return (
        '{"type": "conversation", "id": "' +
        conversationId +
        '", "userId": "' +
        userId +
        '"}'
      );
    },
  },

  iup: {
    uploadAccess: function (userId) {
      return '{"type": "iup-uploader", "id": "' + userId + '"}';
    },
    fullAccess: function (iupId, userId) {
      return (
        '{"type": "iup-admin", "id": "' +
        iupId +
        '", "userId": "' +
        userId +
        '"}'
      );
    },
    readAccess: function (iupId, userId) {
      return (
        '{"type": "iup", "id": "' + iupId + '", "userId": "' + userId + '"}'
      );
    },
  },
};
